import React from "react";
import Header from "../../components/Header/LandingHeader";

import s from "./History.module.scss";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import useWindowDimensions from "../../components/WindowDimentions/WindowDimentions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { Link } from "react-router";
import PageTitle from "../../components/PageTitle/PageTitle";

type Props = {};

const History = (props: Props) => {
  const { width } = useWindowDimensions();
  return (
    <div>
      {width > 600 ? <Header /> : <MobileHeader />}

      <div className={s.content}>
        <PageTitle className={s.h2} eyebrow="About us" title="History" />
        <div className={s.text}>
          The countries of the Caucasus region and Central Asia play a vital
          role in the global market, contributing to the development of the
          world economy and logistics. Historically, Central Asia — encompassing
          Kyrgyzstan, Kazakhstan, Tajikistan, Turkmenistan, and Uzbekistan — has
          served as a geostrategic hub connecting Asia and Europe through
          infrastructure, trade, and energy networks. It remains the largest
          landlocked region in the world without access to global seas. Two
          international transport corridors operate in Central Asia:
          <br /> <br /> • the Trans-Caspian International Transport Route (TITR
          or Middle Corridor, passing through Kazakhstan); <br /> • the Southern
          Corridor (passing through Kyrgyzstan, Tajikistan, Uzbekistan, and
          Turkmenistan).
          <br /> <br /> The Middle Corridor, known as the &quot;Trans-Caspian
          International Transport Route&quot; (TITR), is one of the three global
          trade corridors between China and Europe and is an integral component
          of the Belt and Road Initiative, established to create a direct
          transportation link from Asia to Europe. Spanning 4,256 kilometers, it
          includes both land roads and railways, as well as 508 kilometers of
          sea routes. <br />
          <br /> The Trans-Caspian International Transport Route by one
          logistics starts from Southeast Asia and China, runs through
          Kazakhstan, the Caspian sea, Azerbaijan, Georgia and further to
          European countries.  But by another logistics, the corridor begins in
          the Chinese city of Kashgar and continues through Kyrgyzstan and
          Uzbekistan to the port of Türkmenbashy on the Caspian Sea coast in
          Turkmenistan. From there, goods are transported in containers through
          Azerbaijan and Georgia to the railway station in Kars in northern
          Turkey, and then onward to Turkish sea ports before reaching Europe.{" "}
          <br />
          <br />
          Despite the importance and significance of this corridor and the
          friendly relations, as well as the political will between our
          countries, there is still no flexible mechanism to ensure the fast
          movement of goods and vehicles across our borders. <br />
          <br />
          Based on this, the{" "}
          <strong>
            <Link
              to="https://customs.gov.md/en"
              target="_blank"
              rel="noopener noreferrer"
              className={s.link}
            >
              National Customs Association of the Republic of Moldova
            </Link>
          </strong>{" "}
          decided to unite efforts under a single ‘ideological umbrella’ to
          address this global challenge by establishing the &nbsp;
          <strong>Middle Corridor Transit Advisory Committee - MCTAC.</strong>
        </div>
      </div>
      <LandingFooter />
    </div>
  );
};

export default History;
